import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from '../shared/services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {combineLatest, Subscription} from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: [
    '../shared/styles/login-form.component.css',
    './login.component.css'
  ]
})
export class LoginComponent implements OnInit, OnDestroy {

  loginForm: UntypedFormGroup;
  isLoading: boolean;
  errorMessage: string;
  message: string;
  loginSubscription: Subscription;
  loginSuccessSubscription: Subscription;
  queryParamsSubscription: Subscription;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private authService: AuthService
  ) {
  }

  ngOnInit(): void {
    this.setSubscriptions();
    this.setForm();
    this.onSubscribeToAutoLoginWithGetParams();
  }

  onSubscribeToAutoLoginWithGetParams(): void {
    this.queryParamsSubscription = this.route.queryParams
      .subscribe(params => {
          if (params && params.u && params.token) {
            this.authService.onLoginWithGetParams(params.u, params.token).subscribe(res => {

            });
          }
        }
      );
  }

  setSubscriptions(): void {
    this.loginSuccessSubscription = combineLatest([
        this.authService.userSubject
      ]
    ).subscribe(([user]) => {
      if (user) {
        this.onLoginSuccess();
        this.isLoading = false;
      }
    });
  }

  setForm(): void {
    this.loginForm = new UntypedFormGroup({
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
      password: new UntypedFormControl(null, [Validators.required])
    });
  }

  onLogin() {
    this.resetErrorMessage();
    if (this.loginForm.valid) {
      this.isLoading = true;
      this.loginSubscription = this.authService.onLogin(this.loginForm.value).subscribe(() => {
      }, (error) => {
        this.errorMessage = error.message;
        this.isLoading = false;
      });
    }
  }

  onLoginSuccess() {
    if (this.loginSuccessSubscription) {
      this.loginSuccessSubscription.unsubscribe();
    }
    const currentPath = this.router.url.split('?')[0].split('#')[0];
    if (currentPath === '/login') {
      this.router.navigateByUrl(this.resolveRedirectUrl());
    }
  }

  /**
   * Post-login redirect target: the `returnUrl` query param when it is a safe
   * in-app path, otherwise the default `/graph`. Rejecting protocol-relative
   * (`//host`) and absolute URLs prevents open-redirect attacks.
   */
  resolveRedirectUrl(): string {
    const returnUrl = this.route.snapshot.queryParams.returnUrl;
    if (returnUrl && returnUrl.startsWith('/') && !returnUrl.startsWith('//')) {
      return returnUrl;
    }
    return '/graph';
  }

  resetErrorMessage(): void {
    this.errorMessage = null;
  }

  ngOnDestroy(): void {
    if (this.loginSubscription) {
      this.loginSubscription.unsubscribe();
    }
    if (this.loginSuccessSubscription) {
      this.loginSuccessSubscription.unsubscribe();
    }
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }
  }
}
